<template>
  <!-- Snackbar for alert notifications -->
  <v-snackbar
    v-model="notification"
    bottom
    left
    :color="type"
    :timeout="timeout"
  >
    {{ notificationText }}

    <template #action="{ attrs }">
      <v-btn
        v-if="hasButton"
        :color="buttonColor"
        text
        v-bind="attrs"
        @click="closeNotification"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>

import { ref } from '@vue/composition-api';
import { EventBus } from '../../helpers/utils';

export default {
  setup () {
    const buttonColor = ref(null);
    const hasButton = ref(true);
    const notificationText = ref(null);
    const notification = ref(false);
    const timeout = ref(-1);
    const type = ref(null);

    const colors = {
      error: '#ff5252',
      success: '#4caf50',
      info: '#2196f3'
    };

    const addNotification = params => {
      const { text } = params;
      const options = params.options ? params.options : {};

      // Hide previous notification
      notification.value = false;

      // Display new notification (but give time for previous to disappear)
      setTimeout(() => {
        notificationText.value = text;
        notification.value = true;

        // Customization
        buttonColor.value = options.type ? 'white' : 'pink';
        hasButton.value = !!options.buttonText;
        timeout.value = options.timeout ? options.timeout : 4000;
        type.value = options.type ? colors[options.type] : null;

        // Closeable snackbars override other properties
        if (options.closeable) {
          hasButton.value = true;
        }
      }, 100);
    };

    const closeNotification = () => {
      notification.value = false;
    };

    EventBus.$on('show-notification', addNotification);

    return { notification, type, timeout, notificationText, hasButton, buttonColor, closeNotification };
  }
};
</script>
